// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zLKf","col":"styles_col__cymuO"};